export default __webpack_public_path__ + "media/images/home-app-ios-f0f81531.png";